<template>
    <div class="addstu">
        <div class="avatar">
            <div class="contianer dfx">
                <el-button class="go_back" @click="goBack">
                <img src="../assets/previous.svg" alt="返回上一级" />
                </el-button>
                <div class="column">{{ column }}</div>
            </div>
        </div>
        <div class="asstes">
          <div class="contianer">
            <div class="title">修改个人资料</div>
            <el-form ref="form" :model="form" :rules="rules" >
              <el-form-item label="账号：" prop="nickname">
                <span class="text-primary">{{ form.account }}</span>
              </el-form-item>
              <el-form-item label="姓名：" prop="name">
                <el-input v-model="form.name" maxlength="10" placeholder="输入姓名"></el-input>
              </el-form-item>
              <!-- <el-form-item label="头像">
    <el-image
      style="width: 100px; height: 100px"
      :src="form.avatar"
      :preview-src-list="[form.avatar]"
      fit="cover"
    ></el-image>
  </el-form-item> -->
            <el-form-item label="头像：">
              <!-- <el-upload
                class="avatar-uploader"
                action="/adminapi/upload/image"
                :headers="getUploadHeaders()"
                :show-file-list="false"
                :on-success="(response, file, fileList) => handleSuccess(response, file, fileList, 'avatar')"
                :before-upload="beforeAvatarUpload"
              >
                <img v-if="form.avatar" :src="form.avatar" style="width: 100px; height: 100px">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <span style="color:rgb(192 203 210)">点图片修改头像</span>
              </el-upload> -->
               <!-- 上传区域1 -->
              <div class="upload-group">
                <el-upload
                  action="/adminapi/upload/image"
                  :headers="getUploadHeaders()"
                  :auto-upload="false"
                  :on-change="(file, fileList) => handleChange(0, file, fileList)"
                  :on-success="(response, file, fileList) => handleSuccess(response, file, fileList, 'avatar')"
                  :on-error="handleError"
                  :file-list="files[0].list"
                  list-type="picture-card"
                  ref="uploadRefs0"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <!-- <div class="previews">
                  <img v-if="previews[0]" :src="previews[0]" class="preview-img" />
                  <el-button 
                    v-if="previews[0]" 
                    @click="handleRemove(0)" 
                    type="danger" 
                    size="mini"
                  >删除</el-button>
                </div> -->
              </div>
            </el-form-item>
              
              <el-form-item label="中心电话：" prop="mobile">
                 <el-input v-model="form.org_mobile" placeholder="显示在报告上，默认用所在组织的" maxlength="11"></el-input>
              </el-form-item>
              <el-form-item label="中心地址：">
                <el-input v-model="form.org_address" maxlength="10" placeholder="显示在报告上，默认用所在组织的"></el-input>
              </el-form-item>
              
               <el-form-item label="老师二维码：">
              <!-- <el-upload
                class="avatar-uploader"
                action="/adminapi/upload/image"
                :headers="getUploadHeaders()"
                :show-file-list="false"
                :on-success="(response, file, fileList) => handleSuccess(response, file, fileList, 'teacher_qrcode')"
                :before-upload="beforeAvatarUpload"
              >
                <img v-if="form.avatar" :src="form.avatar" style="width: 100px; height: 100px">
                <i v-else class="el-icon-pl
             us avatar-uploader-icon"></i>
                <span style="color:rgb(192 203 210)">点图片修改（报告用，默认用所在组织的）</span>
              </el-upload> -->
              <!-- 上传区域1 -->
              <div class="upload-group">
                <el-upload
                  action="/adminapi/upload/image"
                  :headers="getUploadHeaders()"
                  :auto-upload="false"
                  :on-change="(file, fileList) => handleChange(1, file, fileList)"
                  :on-success="(response, file, fileList) => handleSuccess(response, file, fileList, 'teacher_qrcode')"
                  :on-error="handleError"
                  :file-list="files[1].list"
                  list-type="picture-card"
                  ref="uploadRefs1"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                （报告用，默认用所在组织的）
              </div>
            </el-form-item>
            <el-form-item label="更多二维码：">
              <!-- <el-upload
                class="avatar-uploader"
                action="/adminapi/upload/image"
                :headers="getUploadHeaders()"
                :show-file-list="false"
                :on-success="(response, file, fileList) => handleSuccess(response, file, fileList, 'more_qrcode')"
                :before-upload="beforeAvatarUpload"
              >
                <img v-if="form.avatar" :src="form.avatar" style="width: 100px; height: 100px">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <span style="color:rgb(192 203 210)">点图片修改（报告用，不填默认用所在组织的）</span>
              </el-upload> -->
              <div class="upload-group">
                <el-upload
                  action="/adminapi/upload/image"
                  :headers="getUploadHeaders()"
                  :auto-upload="false"
                  :on-change="(file, fileList) => handleChange(2, file, fileList)"
                  :on-success="(response, file, fileList) => handleSuccess(response, file, fileList, 'more_qrcode')"
                  :on-error="handleError"
                  :file-list="files[2].list"
                  list-type="picture-card"
                  ref="uploadRefs2"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                （报告用，默认用所在组织的）
              </div>
            </el-form-item>
            
            <el-form-item class="btn">
                <el-button type="primary" @click="submitForm()">保存信息</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
    </div>
</template>
<script>
import { setUserInfo } from '@/api/user'
import { Loading } from 'element-ui'
import useUserStore from '../stores/modules/user'
export default {
  name: 'Myself',
  created () {
    this.userStore = useUserStore()
  },
  data () {
    return {
      userStore: null,
      loadingInstance: null,
      model: 'add',
      column: '新增学员',      
      files: [
        { list: [{
            name: 'avatar',
            url: '',
            status: '' // 必须包含 status 字段
          }] },  // 区域1的文件列表
        { list: [{
            name: 'teacher_qrcode',
            url: '',
            status: '' // 必须包含 status 字段
          }] },  // 区域2
        { list: [{
            name: 'more_qrcode',
            url: '',
            status: '' // 必须包含 status 字段
          }] }   // 区域3
      ],
      previews: ['', '', ''],  // 存储三个区域的预览图 URL
      // 使用数组形式存储ref
      uploadRefs: ['uploadRefs0', 'uploadRefs1', 'uploadRefs2'],
      form: {
        account: '',
        name: '',
        avatar: '',
        org_mobile: '',
        org_address: '',
        teacher_qrcode:'',
        more_qrcode:''
      },
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
      },
      totalFiles: 0, // 总文件数量
      uploadedFiles: 0, // 已上传的文件数量
    }
  },
  mounted () {
    // console.log(this.$route.query)
    /* if (this.$route.query.id) {
      this.model = 'edit'
      this.getDetail()
    } */
    this.getUser()
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    getUploadHeaders () {
      return {
        Token: this.userStore.token
      }
    },
    // 获取个人设置
    async getUser () {
      await this.userStore.getUserInfo()
      this.form = this.userStore.userInfo // , this.userStore.routes, this.userStore.perms   userInfo
      console.log(this.form)
      this.files[0].list[0].url = this.form.avatar
      this.files[1].list[0].url = this.form.teacher_qrcode
      this.files[2].list[0].url = this.form.more_qrcode
      // 状态:0-等待测评,1-等待报告(也是测试中的),2-查看报告（测试完成的）
      //this.statusCount = this.userStore.statusCount
      //console.log('====88888=======',this.files)
        // for (const key in formData) {
        //     // formData[key] = userInfo[key]
        // }
    },
    async getDetail () {
      // 显示加载层
      this.loadingInstance = Loading.service({ fullscreen: true })
      const detail = getUserDetail({id: this.$route.query.id})
      let that = this
      detail.then(function (data) {
                // 在这里处理数据
                // console.log('===client:==', data)
                that.form = data
                that.files[0].list.push(that.form.avatar)
                console.log('===error:==', that.files)
                that.loadingInstance && that.loadingInstance.close()
                // that.$router.push('/mystudents') // goBack()
            }).catch(function (error) {
                // 在这里处理错误3
                console.log('===error:==', error)
            })
    },
    handleClick (tab, event) {
      console.log(tab, event)
    },
    /* enter () {
      this.$router.push({ nickname: 'track' })
    }, */ 
    saveData () {
      let that = this;
      this.$refs['form'].validate((valid) => {
        console.log('======form====',this.form)
        if (valid) {
          // alert('submit!')
          // 显示加载层
          this.loadingInstance = Loading.service({ fullscreen: true })
          const waitOk = setUserInfo(this.form)
          // console.log(waitOk)
          waitOk.then(function (data) {
              // 在这里处理数据
              // console.log('===client:==', data)
              // that.$router.push('/mystudents') // goBack()
              that.loadingInstance && that.loadingInstance.close()
          }).catch(function (error) {
              // 在这里处理错误3
              console.log('===error:==', error)
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
 
    
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 或 PNG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isJPG && isLt2M
    },
     // 处理文件选择变化
     handleChange(index, file, fileList) {
      //console.log(fileList)
      // 限制每个区域只能上传一个文件
      if (fileList.length > 1) {
        fileList.splice(0, 1);
        return;
      }
      if(fileList.length === 1 && fileList[0].status === 'ready') {
        this.totalFiles++
      }

      this.files[index].list = fileList;
     


      // 生成预览图
      if (file.raw) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.previews.splice(index, 1, e.target.result);
        };
        reader.readAsDataURL(file.raw);
      }
    },

    // 删除指定区域的预览
    handleRemove(index) {
      this.files[index].list = [];
      this.previews.splice(index, 1, '');
    },

    // 统一提交所有区域的上传
    async submitAll2() {
      //console.log(this.uploadRefs)
      let noUplaod = true;
      try {
        for(let i = 0;i < 3; i++){
          if(this.files[i].list[0].status !== 'success'){
            this.$refs['uploadRefs'+i].submit();  // 调用每个上传组件的提交方法
            noUplaod = false;
          }
        }
      } catch (error) {
        console.error('上传失败:', error)
        this.$message.error('文件上传失败')
        return false
      }
      if(noUplaod){
        this.saveData();
        return true;
      }
    },
     // 获取当前所有上传组件中的文件数量并开始上传
     submitAll() {
      this.uploadedFiles = 0;
      //this.totalFiles = this.getTotalFilesCount();
      console.log(this.$refs.uploadRefs0)
      this.$refs.uploadRefs0.submit();
      this.$refs.uploadRefs1.submit();
      this.$refs.uploadRefs2.submit();
    },
    // 获取所有上传组件中文件的总数
    /* getTotalFilesCount() {
      const files1 = this.$refs.uploadRefs0.uploadFiles.length;
      const files2 = this.$refs.uploadRefs1.uploadFiles.length;
      const files3 = this.$refs.uploadRefs2.uploadFiles.length;
      return files1 + files2 + files3;
    }, */
    // 上传成功时的回调
    async handleSuccess(response, file, fileList, extraParam) {
      console.log("额外参数:", extraParam);// 其他为固定参数
      this.form[extraParam] = response.data.uri;
      this.uploadedFiles++; // 增加已上传文件的数量
      this.checkUploadComplete(); // 检查是否所有文件都已上传
    },
    // 上传失败时的回调
    handleError(err, file, fileList) {
      this.uploadedFiles++; // 即使上传失败，仍然增加已上传文件的数量
      this.checkUploadComplete(); // 检查是否所有文件都已上传
    },
    // 检查是否所有文件上传完成
    checkUploadComplete() {
      if (this.uploadedFiles === this.totalFiles) {
        //this.$message.success("所有文件上传完成，正在保存数据...");
        this.saveData(); // 执行保存数据的操作
      }
      //console.log("保存数据.???..",this.uploadedFiles,this.totalFiles);
    },     
    async submitForm () {
        this.submitAll();        
      if(this.totalFiles === 0 ){
        this.saveData(); // 执行保存数据的操作
      }
        return false
    }
  }
}
</script>
<style>
.addstu{
  min-height: 100vh;
  /* background: #efefef; */
}
.addstu .avatar {
  width: 100%;
  background: linear-gradient(90deg, #ff9b00, #accd05);
  padding: 1rem 0;
}
.addstu .avatar .dfx{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.addstu .avatar .column{
  flex: 1;
  text-align: center;
  font-size: 1.13rem;
  font-weight: bold;
  color: #fff;
}
.addstu .asstes .contianer{
  margin: 5% 23% 5%;
  background: #fff;
  /* padding: 1.13rem; */
  border-radius: 1.13rem;
  padding-bottom: 68px;
}
.addstu .asstes .title{
  font-size: 1.13rem;
  font-weight: bold;
  line-height: 4rem;
  border-bottom:1px solid #dedede;
}
.addstu .asstes .el-form{
  width: 100%;
  background: #fff;
  border: none;
}
.addstu .asstes .el-form .el-form-item{
  border-bottom:1px solid #dedede;
  margin-bottom: 0;
}
.addstu .asstes .el-form .el-form-item .el-form-item__label{
  /* width: 7.35rem !important; */
  font-size: 1.13rem;
  font-weight: bold;
  line-height: 4rem;
  text-align: left;
  position: relative;
  color: #000;
  padding-left: 12px;
  padding-right: 0;
}
.addstu .asstes .el-form .el-form-item .el-form-item__label::before{
  position: absolute;
  top: 0;
  left: -3px;
}
/* .addstu .asstes .el-form .el-form-item .el-form-item__label::after{
  content: "*";
  color: #f56c6c;
  margin-left: 4px;
  line-height: 4rem;
} */
.addstu .asstes .el-form .el-form-item .el-form-item__content{
  margin-left: 7.35rem !important;
}
.addstu .asstes .el-form .el-form-item .el-form-item__content .el-textarea__inner{
  padding-top: 1.4rem;
  height: 4rem;
}
.addstu .asstes .el-form .el-form-item .el-form-item__content .el-input{
  line-height: 4rem;
}
.addstu .asstes .el-form .btn .el-form-item__content{
  text-align: center;
}
.addstu .asstes .el-form .el-form-item .el-form-item__content .el-button{
    width: 11.13rem;
    height: 2rem;
    border: 0;
    padding: 0;
    margin-top: 2.5rem;
}
.addstu .asstes .el-form .el-form-item .el-form-item__content .el-button span,
.addstu .asstes .el-form .el-form-item .el-form-item__content .el-button span a{
  font-size: 1rem;
  color: #fff;
}
.addstu .asstes .el-form .el-form-item .el-form-item__content .el-button--primary{
  background: linear-gradient(0deg,#81B337,#ACCD05);
}
.addstu .asstes .el-form .el-form-item .el-form-item__content .el-button--default{
  background: linear-gradient(0deg,#FF9C00,#FF7200);
}
.addstu .asstes .el-form .el-form-item .el-form-item__content .el-radio-group{
  height: 4rem;
  display: flex;
  align-items: center;
}
.addstu .asstes .el-form .el-input__inner,
.addstu .asstes .el-form .el-textarea__inner{
  border:0;
}
.addstu .asstes .el-form .btn{
  border-bottom:  0;
}
.addstu .asstes .el-form .btn .el-form-item__content{
  margin-left: 0 !important;
}

@media (max-width:1024px) {
 .addstu .asstes .contianer {
  margin: 5% auto 5%;
 }
}
.el-form-item__error{
  z-index: 1 !important;
}
.text-primary {
  color: #409EFF; /* Element UI 默认蓝色 */
  font-weight: bold;
  line-height: 64px;
  font-size: 18px;
}





.multi-upload {
  display: flex;
  gap: 20px;
}
.upload-group {
  position: relative;
}
.preview-img {
  width: 150px;
  height: 150px;
  object-fit: cover;
  margin-top: 10px;
}
/* 这里覆盖预览图的样式 */
.el-upload-list--picture-card .el-upload-list__item {
  width: 100px;
  height: 100px;
}
/* 设置上传按钮的样式 */
.el-upload.el-upload--picture-card {
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.upload-group div:first-child {
  display: flex;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/Myself.vue